
export const getActionIcon = (permission) => {
    const action = permission.split('.').pop();

    if (action.includes('create')) return 'add_circle';
    if (action.includes('get') || action.includes('view') || action.includes('read')) return 'visibility';
    if (action.includes('update')) return 'edit';
    if (action.includes('delete')) return 'delete';
    if (action.includes('block')) return 'block';
    if (action.includes('unblock')) return 'lock_open';
    if (action.includes('excel')) return 'file_copy';

    return 'check_circle';
};


export const getSubEntityIcon = (subEntity) => {
    const iconMap = {
        'stories': 'book',
        'templates': 'copy',
        'aitemplates': 'psychology',
        'integrations': 'plug',
        'archive': 'archive',
        'entities': 'database',
        'reports': 'show_chart',
        'training': 'school',
        'usersegments': 'group',
        'whatsapp': 'whatsapp',
        'instagram': 'camera_alt',
        'telegram': 'send',
        'messenger': 'message',
        'list': 'list',
        'block': 'block',
        'unblock': 'lock_open',
        'excel': 'file_download',
        'basic-actions': 'list_alt'
    };

    const key = subEntity.toLowerCase().replace(/\s+/g, '');
    return iconMap[key] || 'list_alt';
};

export const getModuleIcon = (moduleName) => {
    const iconMap = {
        'voice-agent': 'support_agent',
        'user': 'people',
        'visitor': 'group',
        'bannedWord': 'block',
        'chat': 'chat',
        'role': 'tag',
        'topic': 'label',
        'prepared': 'content_copy',
        'welcome': 'message',
        'setting': 'settings',
        'report': 'bar_chart',
        'offlineSupportRequest': 'headset',
        'catalog': 'book',
        'chatbot': 'smart_toy',
        'integration': 'plug',
        'triger': 'flash_on',
        'billing': 'receipt',
        'calendar': 'calendar_today',
        'task': 'checklist',
        'mail': 'email',
        'table': 'table_chart',
        'automation': 'autorenew',
        'form': 'check_box',
        'drive': 'storage',
        'bannedVisitor': 'block',
    };

    const key = moduleName.toLowerCase().replace(/\s+/g, '');
    return iconMap[key] || 'help';
};
